import axios from 'axios'

// @ts-ignore
export class CourseServices {

    static async fetchCourse(courseId: number) {
        return axios.get(CourseServices.getContextRoute() + "/api/course/" + courseId)
    }

    static async subscriptionEmail(email: string) {
        return axios.get(CourseServices.getContextRoute() + '/api/course/subscriptionEmail?email=' + email)
    }

    static async subscribe(params: URLSearchParams) {
        return axios.post(CourseServices.getContextRoute() + '/api/course/subscribe', params)
    }

    static async unsubscribe(params: URLSearchParams) {
        return axios.post(CourseServices.getContextRoute() + '/api/course/unsubscribe', params)
    }

    static getContextRoute(): string {
        const baseURL = import.meta.env.BASE_URL;
        const contextRoot = baseURL !== '/' ? baseURL : '';
        return contextRoot;
    }

}
